/// <amd-module name="typeahead/core/message/InputValueEditedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class InputValueEditedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.input_value_edited";
    }

    private readonly newInputValue: string;
    private readonly domElementId: string;
    private readonly lob: string;

    constructor(newInputValue: string, lob: string, domElementId: string) {
        this.newInputValue = newInputValue;
        this.domElementId = domElementId;
        this.lob = lob;
    }

    public getTopic(): string {
        return InputValueEditedMessage.getTopic();
    }

    public getNewInputValue(): string {
        return this.newInputValue;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getLob(): string {
        return this.lob;
    }
}
